import { Drawer, Menu } from '@mantine/core'
import type { StackedChartSection } from 'components/StackedChart/types'
import React from 'react'
import { colors } from 'settings/colors'
import { SharedSettings } from 'settings/SharedSettings'

type TMobileSettingsDrawerProps = {
  opened: boolean
  onClose: () => void
  optionsTop?: React.ReactNode
  options?: NonNullable<StackedChartSection['titleLink']>
}

export const MobileSettingsDrawer = ({
  opened,
  onClose,
  options,
  optionsTop,
}: TMobileSettingsDrawerProps) => {
  return (
    <Drawer
      position="bottom"
      opened={opened}
      onClose={onClose}
      // one below the settings pages it opens: all portals share one node, so a tie would go to
      // mount order and this sheet would paint over them
      zIndex={SharedSettings.DEFAULT_MODAL_DRAWER_Z_INDEX - 1}
      styles={{
        content: {
          height: 'auto',
          paddingBottom: 'env(safe-area-inset-bottom)',
          borderTopLeftRadius: '16px',
          borderTopRightRadius: '16px',
        },
      }}
    >
      {optionsTop && (
        <div css={{ paddingBottom: '20px', borderBottom: `1px solid ${colors.grey200}` }}>
          <span>{optionsTop}</span>
        </div>
      )}

      <Menu
        withinPortal={false}
        position="bottom-start"
        transitionProps={{ transition: 'pop' }}
        styles={{
          dropdown: {
            padding: 0,
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
      >
        {options?.map((option, index) => (
          <div
            key={index}
            onClick={onClose}
            css={{ borderTop: `1px solid ${index > 0 ? colors.grey200 : 'transparent'}` }}
          >
            {option}
          </div>
        ))}
      </Menu>
    </Drawer>
  )
}
